export default class EquipmentType {
  id = -1;
  archived = false;
  name = "";
  description = "";
  component_type_ids = [];
  component_types = []; // { archived, id, name }[]
  links = {
    edit: "",
    archive: "",
    unarchive: "",
  };

  constructor(params) {
    Object.assign(this, params);
    if (this.component_types.length) {
      this.component_type_ids = this.component_types.map(
        componentType => componentType.id
      );
    }
  }

  toAPI() {
    return {
      ...this,
      component_types: undefined,
    };
  }

  static fromAPI(response) {
    return new EquipmentType(response);
  }
}
